import ListAltIcon from '@material-ui/icons/ListAlt';
import { CsvReportList } from './CsvReportList';

export const csvReportResource = {
  list: CsvReportList,
  icon: ListAltIcon,
};
